<div class="row" style="margin-top: 50px" data-ng-show="ctrl.show">
    <div class="col-xs-12 col-sm-6 col-sm-offset-3">
      <div class="wrapper">
        <div class="row">
          <h3 i18n>Upgrade required</h3>
        </div>

        <div class="row">
          <p i18n>
            risr/advance has been updated and needs to be reloaded. This will happen automatically within 15 seconds.
          </p>
          <p i18n>Alternatively you can reload manually by clicking the button below.</p>

        </div>
        <div class="row">
          <div class="col-sm-6">
            <p><button type="button" class="btn btn-info" (click)="reload()" i18n>Reload</button>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
